import React from "react";
import { ISearchField, ISearchProp } from "../Types";
import { ISelectOption } from "@/types/FmsTypes";
import YhDebounceSelect from "@/components/YhDounceSelect";

type PropType = ISearchProp & ISearchField;
export const DebounceSelect = (props: PropType) => {

	function fn(): Promise<ISelectOption[]> {
		let arr: ISelectOption[] = [];
		return Promise.resolve(arr)
	}

	return (
		<YhDebounceSelect
			// mode="multiple"
			showSearch
			allowClear
			className="ant-select-round"
			disabled={props.disabled}
			value={props.searchValues?.[props.fieldName]}
			placeholder={props.placeholder}
			fetchOptions={props?.selectfetchList ?? fn}
			onChange={(value) => {
				// console.log(value)
				props.onChange?.({ [props.fieldName]: value })
				if (props.triggerSearch) props.handleSearch?.({ [props.fieldName]: value });
			}}
			style={{ width: '100%' }}
		/>
	);
}


